import { Operacao } from "../components/TableListaOperacoes/interfaces";
import { RespostasSelecionadasQuestionarioVDSubmit } from "./QuestionarioPerguntasRespostas";
import AcompanhamentoVistoria from "./acompanhamento-vistoria-desembolso";
import { Anexo } from "./anexo";
import { BemImovel } from "./bem-imovel";
import { DetalheComprovacaoFisica, ResumoComprovacaoFisica } from "./comprovacao-fisica";
import CriticaOrcamentoResultados from "./criticaOrcamentoResultados";
import { EdicaoLaudoAvaliacaoDeQualidadeResponseVO, EdicaoLaudoAvaliacaoDeQualidadeVO } from "./dados-avaliacao-de-qualidade";
import EdicaoLaudoParecerTecnicoVO from "./dados-parecer-tecnico";
import { DadosVistoriaDesembolso } from "./dados-vistoria-desembolso";
import DiagnosticoMetodologia from "./diagonostico-metodologia";
import DocumentoGed from "./documento-ged";
import IdentificacaoObra from "./identificacao-obra";
import ImovelLaudo from "./imovel-vistoria-desembolso";
import LaudoCusto from "./laudo-custo";
import LaudoObra from "./laudoObra";
import LocalizacaoEmpreendimentoVO from "./localizacao-empreendimentos";
import { MetodosProcedimentos } from "./metodosProcedimentos";
import ObjetivoLaudo from "./objetivo-laudo";
import PropostaParecerTecnico from "./proposta-parecer-tecnico";
import { TratamentoResultadoType } from "./tratamento-resultado";
import Vistoria from "./vistoria";
import VistoriaDesembolso from "./vistoria-desembolso";
import { RespostaPTR, SituacaoDocumentacaoPTR, ViabilidadeTecnicaPTR } from "./respostas-parecer-tecnico-rural";
import { ResultadoPTR } from "./resultadoPTR";
import ConvalidacaoDaProposta from "./convalidacao-proposta";
import { AvaliacaoAnimais } from "./avaliacao-animais";
import { DetalheDocumentoMetodologiaResultado } from "./DocumentacaoMetodologiaResultado";
import VistoriaAnimal from "./vistoria-animal";

export default class Laudo {
	dataSolicitacaoLaudo = 0;
	id = 0;
	idLaudoAvaliacao: number;
	idAS?: number;
	alocacaoId: number;
	quantidadeTecnicosAlocados: number;
	codigoTipoCaracteristica = 1;
	codMunicipio = 0;
	descTipoLaudo = "";
	codigoAgenciaSolicitante = 1;
	nomeAgenciaSolicitante = "";
	bairroAgenciaSolicitante = "";
	descMunicipioJurisdicao = "";
	sequencial = 0;
	nomeFantasiaCliente = "";
	telefoneCliente = "";
	situacaoLaudo = "";
	numeroLaudoFormatado = "";
	dataSolicitacaoLaudoFormatada = "";
	agenciaSolicitante = "";
	siglaUf = "";
	valor = 0;
	descTipoCaracteristica = "";
	cpfcnpj = 0;
	cpfCnpj = "";
	sicad = "";
	siat = "";
	dataSiat = "";
	nomeContato = "";
	telContato = "";
	descricao = "";
	descMotivo = "";
	orgaoSiat = "";
	anoSolicitacaoSiat = "";
	seqAtividadeSiat = "";
	acoes: number[];
	custoLaudoVO: LaudoCusto = new LaudoCusto();
	codigoSicad: number;
	codigoTipoLaudo: number;
	codigoExternoAgenciaSolicitante: number;
	codigoAgenciaJurisdicao: number;
	codigoSituacao: number;
	codigoUf: number;
	documentos: Array<DocumentoGed>;
	bensImoveis: Array<BemImovel>;
	bensImoveisExcluidos: Array<BemImovel>;
	documentosLaudo: Array<DocumentoGed>;
	documentosViagem: Array<DocumentoGed>;
	documentosViagemExcluidos: Array<DocumentoGed>;
	imoveis: Array<ImovelLaudo>;
	justDocCartAdicional?: string;
	anexos?: Array<Anexo>;
	vistoria: Vistoria;
	vistoriaDesembolsoRural?: VistoriaDesembolso;
	vistoriaAnimal: VistoriaAnimal;
	objetivo: ObjetivoLaudo;
	diagnosticoMetodologia?: DiagnosticoMetodologia;
	tratamentoResultado?: TratamentoResultadoType;
	abaAtual?: number;
	paginaAtual?: string;
	focus?: string;
	isAporteRecursos = false;
	tipoDeclaracao?: string;
	tipoAvaliacaoImovel?: string;
	naoNecessitaDocumentoViagem?: boolean;
	totalDocumentosViagemOutrosUsuarios: number;
	justificativaDocumentoViagem?: string;
	operacao?: Operacao;
	resumoComprovacaoFisica?: ResumoComprovacaoFisica;
	detalhesComprovacaoFisica?: Array<DetalheComprovacaoFisica>;
	detalhesDocumentos?: Array<DetalheDocumentoMetodologiaResultado>;
	acompanhamentoVistoria: AcompanhamentoVistoria;
	siglaTipoCaracteristica: string;
	siglaTipoLaudo?: string;
	dadosVistoriaDesembolsoVO?: DadosVistoriaDesembolso;
	respostasSelecionadas?: RespostasSelecionadasQuestionarioVDSubmit[];
	laudoObraVO?: LaudoObra;
	identificacaoObraVO: IdentificacaoObra;
	codigoLaudoCriticaOrcamento: number;
	codigoLaudoAnimal: number;
	metodosProcedimentosVO: MetodosProcedimentos;
	criticaOrcamentoResultadosVO: CriticaOrcamentoResultados;
	numeroLaudoFormatadoAvaliado?: string;
	valorAvaliado?: string;
	codigoTipoCaracteristicaAvaliado?: number;
	siglaTipoCaracteristicaAvaliado?: string;
	descTipoCaracteristicaAvaliado?: string;
	codigoTipoLaudoAvaliado: number;
	descTipoLaudoAvaliado?: string;
	dataConclusaoLaudoAvaliado?: Date;
	dataConclusaoLaudoAvaliadoFormatada?: string;
	anexosLaudoAvaliado?: Anexo[];
	edicaoLaudoAvaliacaoDeQualidadeVO?: EdicaoLaudoAvaliacaoDeQualidadeVO;
	edicaoLaudoAvaliacaoDeQualidadeResponseVO?: EdicaoLaudoAvaliacaoDeQualidadeResponseVO;
	localizacaoEmpreendimento: LocalizacaoEmpreendimentoVO;
	edicaoLaudoParecerTecnico: EdicaoLaudoParecerTecnicoVO;
	propostaParecerTecnico?: PropostaParecerTecnico;
	siglaUFVO?: string;
	situacaoDocumentacaoPTRVO?: SituacaoDocumentacaoPTR;
	viabilidadeTecnicaPTRVO?: ViabilidadeTecnicaPTR;
	resultadoPTRVO?: ResultadoPTR;
	convalidacaoDaProposta?: ConvalidacaoDaProposta;
	avaliacaoAnimais?: AvaliacaoAnimais;
	docViagemCadastrado?: boolean;
	melhoriaDiagnosticoMetodologia?: boolean;
	melhoriaVistoria?: boolean;
}
